import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import * as ApexCharts from 'apexcharts';

@Component({
    selector: 'app-reusable-apex-chart',
    templateUrl: './reusable-apex-chart.component.html',
    styleUrls: ['./reusable-apex-chart.component.scss'],
    standalone: false
})
export class ReusableApexChartComponent implements AfterViewInit, OnChanges, OnDestroy {
 @ViewChild('chartContainer', { static: true }) chartContainer!: ElementRef;
  @Input() options: any;

  private chart: any;

  ngAfterViewInit(): void {
    this.loadChart();
  }

  ngOnChanges(): void {
    if (this.chartContainer) {
      this.loadChart();
    }
  }

  loadChart(): void {
    if (this.chart) {
      this.chart.destroy();
    }

    if (this.options) {
      this.chart = new ApexCharts(this.chartContainer.nativeElement, this.options);
      this.chart.render();
    }
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
    }
  }
  
}
